import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubbleHeart"><Path d="M20.5 3.50002L3.5 3.5V18.5L9.0155 18.5L11.9979 21L15.0155 18.5H20.5V3.50002Z" stroke="currentColor"/><Path d="M15.5 10.6089C15.5 13.1212 12 14.5 12 14.5C12 14.5 8.5 13.1212 8.5 10.6089C8.5 8.7261 10.3813 7.60517 12 8.65126C13.6187 7.60517 15.5 8.7261 15.5 10.6089Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconBubbleHeart;
